import axios from "axios";
const API_URL = "/.netlify/functions";
const instance = axios.create({
  baseURL: API_URL,
});
export const postWithHeader = (url: any, data: any, header: any) => {
  return new Promise((resolve, reject) => {
    instance
      .post(url, data, header)
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
